export default __webpack_public_path__ + "static/media/Digory_Doodles_PS.7112112c.ttf";